import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Communication(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Communication", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.7026 10.7837H7.3513c-1.15403 0-2.26081.5382-3.07683 1.4961C3.45844 13.2378 3 14.537 3 15.8918s.45844 2.654 1.27447 3.612c.81602.9579 1.9228 1.4961 3.07683 1.4961h1.45044l2.90086 3.4054v-3.4054c1.154 0 2.2608-.5382 3.0768-1.4961.8161-.958 1.2745-2.2572 1.2745-3.612s-.4584-2.654-1.2745-3.612c-.816-.9579-1.9228-1.4961-3.0768-1.4961Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.8671 16.6215H7.18469c-.20697 0-.40547-.0683-.55182-.19-.14635-.1216-.22857-.2866-.22857-.4586 0-.1721.08222-.3371.22857-.4587.14635-.1216.34485-.19.55182-.19h4.68241c.2069 0 .4054.0684.5518.19.1464.1216.2286.2866.2286.4587 0 .172-.0822.337-.2286.4586-.1464.1217-.3449.19-.5518.19Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.2974 3H18.7029c-.4014 0-.7863.17085-1.0702.47496-.2838.30411-.4433.71658-.4433 1.14666v6.48648c0 .4301.1595.8426.4433 1.1467.2839.3041.6688.4749 1.0702.4749h6.8108v3.2433l3.0269-3.2433h.7568c.4014 0 .7864-.1708 1.0702-.4749.2838-.3041.4433-.7166.4433-1.1467V4.62162c0-.43008-.1595-.84255-.4433-1.14666C30.0838 3.17085 29.6988 3 29.2974 3Zm12.7237 5.18896h-5.9594c-.7902 0-1.5481.3417-2.1069.94993-.5588.60822-.8728 1.43311-.8728 2.29331v3.2433c0 .8601.314 1.685.8728 2.2933.5588.6082 1.3167.9499 2.1069.9499h2.9797v3.2432l2.9797-3.2432c.7903 0 1.5482-.3417 2.107-.9499.5588-.6083.8727-1.4332.8727-2.2933v-3.2433c0-.8602-.3139-1.68509-.8727-2.29331-.5588-.60823-1.3167-.94993-2.107-.94993Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41.4505 13.3784h-4.2567c-.1881 0-.3686-.0684-.5016-.19-.1331-.1217-.2078-.2867-.2078-.4587s.0747-.337.2078-.4587c.133-.1216.3135-.1899.5016-.1899h4.2567c.1882 0 .3686.0683.5017.1899.133.1217.2078.2867.2078.4587s-.0748.337-.2078.4587c-.1331.1216-.3135.19-.5017.19ZM26.1283 8.83782h-4.2567c-.1882 0-.3686-.06833-.5017-.18998-.133-.12164-.2078-.28663-.2078-.45866 0-.17204.0748-.33702.2078-.45867.1331-.12164.3135-.18998.5017-.18998h4.2567c.1881 0 .3686.06834.5016.18998.1331.12165.2078.28663.2078.45867 0 .17203-.0747.33702-.2078.45866-.133.12165-.3135.18998-.5016.18998Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.1622 44.6486V21.6432c0-.4358-.174-.8537-.4836-1.1619-.3097-.3082-.7296-.4813-1.1675-.4813h-14.86c-.4379 0-.8579.1731-1.1675.4813-.3096.3082-.4836.7261-.4836 1.1619v23.0054h18.1622Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36 22H20v18h16V22Zm-7.3766 21.3512c.5373 0 .9729-.4356.9729-.973 0-.5373-.4356-.9729-.9729-.9729-.5374 0-.973.4356-.973.9729 0 .5374.4356.973.973.973Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.9745 29.7295h16.7568c.4444 0 .8706.1757 1.1848.4885.3143.3128.4908.7371.4908 1.1794v10.0078H4.29883V31.3974c0-.4423.17654-.8666.49079-1.1794.31425-.3128.74047-.4885 1.18488-.4885Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M22.4609 40v-8.9731H6.24472V40H22.4609Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3 41.4053h23.3514v1.6216c0 .4301-.1758.8425-.4886 1.1467-.3128.3041-.737.4749-1.1794.4749H4.66795c-.44237 0-.86662-.1708-1.17942-.4749C3.17573 43.8694 3 43.457 3 43.0269v-1.6216Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M15.9738 41.4053h-3.2432v1.9459h3.2432v-1.9459Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.5753 26.4863h7.8764c.4178 0 .8185.174 1.1139.4836.2955.3097.4614.7296.4614 1.1675v1.6511H34v-1.6511c0-.4379.166-.8578.4614-1.1675.2954-.3096.6961-.4836 1.1139-.4836ZM34 41.3463h11.027v1.6511c0 .4379-.1659.8579-.4614 1.1675-.2954.3096-.6961.4836-1.1139.4836h-7.8764c-.4178 0-.8185-.174-1.1139-.4836-.2954-.3096-.4614-.7296-.4614-1.1675v-1.6511Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M45 28H34v15h11V28Z", fill: theme.vars.palette.secondary.dark }),
    /* @__PURE__ */ jsx("path", { d: "M38 28h3v.5h-3V28Z", fill: theme.vars.palette.primary.dark })
  ] });
}
Communication.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Communication"
};
validateTidalLicense();
export {
  Communication
};
//# sourceMappingURL=Communication.js.map
